// extracted by mini-css-extract-plugin
module.exports = {"description":"styles_description__OUO1m","descriptionTitle":"styles_descriptionTitle__USq6L","descriptionButtonWrapper":"styles_descriptionButtonWrapper__1MUF0"};